module.exports = __webpack_public_path__ + "img/team_stage.cfa0a9db.svg";